export default "__VITE_ASSET__8b54ce79__"